import { IPatientConversation } from 'shared/interfaces/patientConversation.interface';
import { http } from '../utils/axios';

class PatientConversationService {
  private static instance: PatientConversationService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): PatientConversationService {
    if (!PatientConversationService.instance) {
      PatientConversationService.instance = new PatientConversationService();
    }

    return PatientConversationService.instance;
  }

  getPatientConversation = async ({
    patientId,
    affiliateId
  }: {
    patientId: string;
    affiliateId: string;
  }) => {
    const { data } = await http<IPatientConversation>({
      url: `/patientConversations/getByPatient/${patientId}?affiliate=${affiliateId}`,
      method: 'GET'
    });
    return data;
  };

  getPatientConversationById = async (id: string) => {
    const { data } = await http<IPatientConversation>({
      url: `/patientConversations/${id}`,
      method: 'GET'
    });
    return data;
  };

  getUnreadCount = async ({ affiliateId }: { affiliateId: string }) => {
    const { data } = await http<{ unread_count: number }>({
      url: `/patientConversations/actions/getMyUnreadCount?affiliate=${affiliateId}`,
      method: 'GET'
    });
    return data;
  };

  joinChannel = async ({ channelId }: { channelId: string }) => {
    await http({
      url: '/patientConversations/actions/joinChannel',
      method: 'POST',
      data: { channelId }
    });
  };
}

const instance = PatientConversationService.getInstance();

export default instance;
